var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#DCE6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 9C12.1338 9 9 12.1338 9 15.9996C8.9999 16.9189 9.18091 17.8293 9.53268 18.6786C9.88444 19.528 10.4001 20.2998 11.0501 20.9498C11.7002 21.5999 12.472 22.1155 13.3213 22.4673C14.1707 22.819 15.081 23.0001 16.0004 23C19.8655 23 23 19.8662 23 15.9996C23 12.1338 19.8655 9 16.0004 9ZM16.6537 11.5272C17.3361 11.5272 17.5366 11.9231 17.5366 12.3759C17.5366 12.9409 17.0846 13.4637 16.3124 13.4637C15.6664 13.4637 15.3587 13.1393 15.3777 12.6019C15.3777 12.1491 15.7561 11.5272 16.6537 11.5272ZM14.9052 20.1921C14.4386 20.1921 14.0981 19.9085 14.424 18.6653L14.9584 16.4597C15.051 16.1068 15.0664 15.9653 14.9584 15.9653C14.8192 15.9653 14.2133 16.2089 13.856 16.4495L13.6234 16.0682C14.7572 15.121 16.0609 14.5654 16.6187 14.5654C17.0853 14.5654 17.1626 15.1166 16.93 15.9653L16.3175 18.284C16.2089 18.6937 16.2556 18.8352 16.3642 18.8352C16.5042 18.8352 16.9621 18.666 17.4127 18.3109L17.6766 18.6653C16.5735 19.7677 15.3711 20.1921 14.9052 20.1921Z",
    fill: "#2574FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e1c52c531020acc918c48a0e9549d05e.svg";
export { ForwardRef as ReactComponent };